import * as PIXI from "pixi.js";
import addInteractivity from "../../../../../../../src/utils/addInteractivity";
import { Coord } from "../../../../../../../src/types/Interface";
import getCleanCoord from "../../../../../../../src/utils/coord/getCleanCoord";
import { cursorEventBus, EnumCursorEventBus } from "../../../../../../../src/entities/UI/CustomCursor/CustomCursorEventBus";
import { CustomCursorType } from "../../../../../../../src/entities/UI/CustomCursor/CustomCursor";


export default class DrawingFactory {
  static addBgInteractivity(bg: PIXI.Graphics, _onHandleDown: (coord: Coord) => void, isPencil: boolean) {
    const onHandleOver = _ => {
      cursorEventBus.emit(EnumCursorEventBus.setRotation, Math.PI / 4)
    }
    const onHandleDown = (e: PIXI.FederatedPointerEvent) => {
      _onHandleDown(getCleanCoord(e.global))
      cursorEventBus.emit(EnumCursorEventBus.setRotation, Math.PI / 4);
    }

    addInteractivity(
      bg,
      {
        handleOverFunc: onHandleOver,
        handleDownFunc: onHandleDown,
      },
      isPencil ? CustomCursorType.pencil : CustomCursorType.target
    );
  }
}